module.exports = __webpack_public_path__ + "static/media/boiler.a4f4d875.svg";